// extracted by mini-css-extract-plugin
export default {"leasing-trademark__container":"ov9xIg9","leasing-trademark__box":"j9xhSZE"};